import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AuthService } from '@auth/services/auth.service';
import { CustomIconsService } from '@services/custom-icons.service';
import { ResultModalService } from '@services/result-modal.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'ftp-platform';
  private customIconsService = inject(CustomIconsService);
  private authService = inject(AuthService);
  private resultModalService = inject(ResultModalService);

  constructor() {
    this.customIconsService.initializeIcons();

    effect(() => {
      if (this.authService.user()) {
        void this.resultModalService.checkAndShowResultModal();
      }
    });
  }
}
